module.exports = __webpack_public_path__ + "images/feature/20150520_project_stats_01-5be08a40ea36ff013c8e4d4e2feeb6c2.png";